// import React, { useState } from 'react'
import Header from '../components/Header';
import ResetRequest from '../components/ResetRequest';

const ResetPasswordRequestPage = () => {
  return (
    <div className="grid lg:grid-cols-2 lg:gap-6 w-full justify-center">
      <div className="hidden lg:block h-full max-h-screen py-8 sticky top-0">
        <div
          className="h-full w-full rounded-md overflow-hidden bg-cover flex flex-col justify-end bg-center"
          style={{ backgroundImage: 'url(/img/login.jpg)' }}
        ></div>
      </div>
      <div className="max-w-sm flex flex-col items-start justify-center min-h-screen mx-auto">
        <Header
          heading="Password reset"
          paragraph="Enter your email to request a password reset"
        />

        <ResetRequest />
      </div>
    </div>
  );
};

export default ResetPasswordRequestPage;
